import { CourseCatalogLandingPageContent } from './course-catalog-landing-page-content.model';
import { CourseCatalogLandingPageCategorySection } from './course-catalog-landing-page-category-section.model';
import { ICourseCatalogLandingPageOverviewQuery } from '../interfaces/course-catalog-landing-page-overview.interface';

// @dynamic
export class CourseCatalogLandingPageOverview {
    landingPage: CourseCatalogLandingPageContent;
    categorySections: CourseCatalogLandingPageCategorySection[];

    constructor(query: ICourseCatalogLandingPageOverviewQuery) {
        this.landingPage = new CourseCatalogLandingPageContent(query.landing_page);
        this.categorySections = query.category_sections.map((categorySection) => new CourseCatalogLandingPageCategorySection(categorySection));
    }
}
